import type { Rule } from "../types";
import { recolorYellowToBlue } from "./recolorYellowToBlue";

export const systemRules: Rule[] = [recolorYellowToBlue];
